export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9538.e71ac11d.jpg";